import { ScanningSchedule } from '../scanners-config/components/scanner-configuration-tabs/tabs/scanning-schedule/scanning-schedule';

const ScanningSchedulePage: React.FC = () => {
  return <ScanningSchedule />;
};

export default ScanningSchedulePage;

export const Component = () => <ScanningSchedulePage />;
